import Validator from "./Validator";

export default class JsonEntitiesValidator extends Validator {
  constructor() {
    super();
    this.validationRules = {
      type: 'array',
      empty: false,
      mandatory: true
    };
  }
}
